
export default {

    setCurrentBordereauLivraison (state, bordereau) {
      state.current = bordereau
    },

    setBordereauxLivraison (state, bordereaux) {
      state.all = bordereaux
      state.initialized = true
      state.page = 1
    },

    setCount(state, count) {
      state.count = count
    },

    setNextBordereauxLivraison (state, bordereaux) {    
      state.all = [ ...state.all, ...bordereaux ]
      state.page++
    },
}